/** @jsxImportSource @emotion/react */
import { css, jsx } from '@emotion/react';
import React, { PropsWithChildren, ReactElement, useCallback, useMemo } from 'react';
import { TableInstance } from 'react-table'
import Pagination from '@atlaskit/pagination';
import { gridSize } from '../theme/constants';
import Select from 'components/select';
import { colors } from '../theme';

const rowsPerPageOptions = [5, 10, 25, 50];

function TablePagination<T extends object>({instance}: PropsWithChildren<{ instance: TableInstance<T> }>): ReactElement | null {
  const {
    state: { pageIndex, pageSize, rowCount = instance.rows.length },
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageOptions,
  } = instance

  const handleChangePage = useCallback(
    (event: React.SyntheticEvent, newPage: any) => {
      const newPageIndex = newPage - 1;
      if (newPageIndex === pageIndex + 1) {
        nextPage()
      } else if (newPageIndex === pageIndex - 1) {
        previousPage()
      } else {
        gotoPage(newPageIndex)
      }
    },
    [gotoPage, nextPage, pageIndex, previousPage]
  );

  const onChangeRowsPerPage = useCallback(
    (option) => {
      setPageSize(Number(option.value))
    },
    [setPageSize]
  );

  const pages = useMemo(()=> {
    return pageOptions.map(pageNumber => pageNumber+1);
  },[pageOptions]);

  const OptimizedPagination = useMemo( () => {
    return <Pagination selectedIndex={pageIndex} pages={pages} onChange={handleChangePage} max={5}/>
  },[pageIndex, pages, handleChangePage]);

  return rowCount >= -1 ?
   <div css={css`
    border-top: 1px solid ${colors.N40};
    padding: ${gridSize()*0.5}px 0px;
    align-items: center;
    display: flex;
    justify-content: space-between;`
   }>
     <div>
       <div css={css`width: 72px; display: inline-block; margin-right: ${gridSize()}px;
`}>
         <Select
           menuPlacement='top'
           options={[
             {label: '10', value: 10},
             {label: '25', value: 25},
             {label: '50', value: 50},
             {label: '100', value: 100},
           ]}
           value={{label: pageSize.toString(), value: pageSize}}
           onChange={onChangeRowsPerPage}
           placeholder="Per page"
           />
       </div>
       per page
     </div>
     <div>
       {OptimizedPagination}
     </div>
   </div>: null;

  // return rowCount ? (
  //   <MuiTablePagination
  //     rowsPerPageOptions={rowsPerPageOptions}
  //     component='div'
  //     count={rowCount}
  //     rowsPerPage={pageSize}
  //     page={pageIndex}
  //     onChangePage={handleChangePage}
  //     onChangeRowsPerPage={onChangeRowsPerPage}
  //   />
  // ) : null
}
// export default React.memo(TablePagination) as typeof TablePagination;
export default TablePagination;
